import React from 'react';
import styled from '@emotion/styled';
// import LogoImg from '../../logo.svg';
import LogoImg from '../../logox1.png';
import LogoImgW from '../../logox1_w.png';
// import LogoImg2 from '../../logo_w.svg';

const LogoTag = styled.img`
    width: 100%;
    box-sizing: border-box;
    padding: 2rem 1.5rem;
`;

export const Logo = (props: {version?: 1 | 2}) => (
    <LogoTag src={props.version === 2 ? LogoImg : LogoImg} alt="Projects" />
);

const LogoTagSmall = styled.img`
    width: 100%;
    box-sizing: border-box;
    padding: 24px 16px 8px;
`;

export const LogoSmall = (props: {version?: 1 | 2}) => (
    <LogoTagSmall src={props.version === 2 ? LogoImgW : LogoImg} alt="Projects" />
);
